<template>
  <div class="shopcart">
    <div class="header">
      客户名称：{{ cardInfo.cardholderName }} 电话：{{ cardInfo.tel }}
    </div>
    <van-divider />
    <div class="main">
      <!-- <van-checkbox  shape="square"> -->
      <div
        v-on:clcik="tobuy"
        v-if="cartList == null || cartList == '' || cartList.length == 0"
      >
        <van-empty description="购物车为空,快去添加商品吧" />
      </div>
      <div class="products" v-else>
        <!-- <van-checkbox-group v-model="selectCartList"> -->
        <div class="cart-item" v-for="(item, idx) in cartList" v-bind:key="idx">
          <div class="cart-left">
            <van-checkbox
              :value="item.goodsSkuId"
              :name="'ck' + idx"
              v-model="item.checked"
              @click="selectGood(item)"
            ></van-checkbox>
          </div>
          <div class="cart-right">
            <van-swipe-cell :before-close="beforeClose">
              <van-card
                :price="item.price"
                :desc="item.remarks"
                :title="item.name"
                :thumb="item.coverImg"
              >
                <template #num>
                  <div style="float: left">
                    <van-stepper
                      @plus="updateGoodNum(item, 1)"
                      @minus="updateGoodNum(item, -1)"
                      @blur="updateGoodNum(item, item.num - item.tempNum)"
                      v-model="item.num"
                      integer
                    />
                  </div>
                </template>
              </van-card>
              <template #right>
                <van-button
                  square
                  text="删除"
                  type="danger"
                  class="delete-button"
                  @click="deleteGood(item)"
                />
              </template>
            </van-swipe-cell>
          </div>
        </div>
        <!-- </van-checkbox-group> -->
      </div>
      <van-goods-action>
        <van-checkbox
          style="margin-left: 10px"
          @click="toggleAll"
          v-model="checkAll"
        ></van-checkbox>
        <div class="totalAmt">总计：{{ totalAmt }}元</div>

        <van-goods-action-button
          style="width: 10px"
          type="danger"
          to="settle"
          :disabled="cartList == null || cartList == '' || cartList.length == 0"
          text="去结算"
        />
      </van-goods-action>
      <!-- </van-checkbox> -->
    </div>
  </div>
</template>

<script>
import "../../assets/css/shopcart.less";
import { apiPost } from "@/api/common";
import { Dialog } from "vant";
// const { checkboxGroup } = this.$refs;
export default {
  name: "ShopCart",
  data() {
    return {
      success: true,
      cartNum: "",
      totalAmt: 0,
      checkAll: false,
      shopInfo: {},
      cardInfo: {},
      cartList: [],
      selectCartList: [],
    };
  },
  components: {},
  created() {
    this.loadComments();
  },
  computed: {},

  methods: {
    loadComments() {
      // debugger;
      let s = sessionStorage.getItem("shopInfo");
      let c = sessionStorage.getItem("cardInfo");
      this.shopInfo = s ? JSON.parse(s) : "";
      this.cardInfo = c ? JSON.parse(c) : "";
      this.getCartList();
    },
    getCartList() {
      let _this = this;
      let url = "/api/order/selectShoppingCart";
      let data = {
        code: this.shopInfo.shopCode,
        mobile: this.cardInfo.tel,
      };
      apiPost(url, data).then((resp) => {
        let _data = resp.data;
        if (_data.code == "0000") {
          _this.cartNum = _data.data.results.totalNum;
          _this.cartList = _data.data.results.orderItemList;
          _this.totalAmt = 0;
          _this.checkAll = true;
          for (let i = 0; i < _this.cartList.length; i++) {
            let item = _this.cartList[i];
            item.tempNum = item.num;
            if (item.isCheck == 0) {
              _this.totalAmt += item.payMoney;
              item.checked = true;
            } else {
              item.checked = false;
              _this.checkAll = false;
            }
          }
          sessionStorage.setItem("totalAmt", _this.totalAmt);
        } else {
          _this.$toast.fail(_data.msg);
        }
      });
    },
    beforeClose({ position, instance }) {
      switch (position) {
        case "left":
        case "cell":
        case "outside":
          instance.close();
          break;
        case "right":
          break;
      }
    },
    //选择购物车商品
    selectGood(data) {
      if (data.isCheck == 0) {
        data.isCheck = 1;
      } else {
        data.isCheck = 0;
      }
      data.num = 0;
      this.updateCartInfo(data);
    },
    deleteGood(data) {
      Dialog.confirm({
        message: "确定删除吗？",
      }).then(() => {
        data.num = data.num * -1;
        this.updateCartInfo(data);
      });
    },
    //修改购物车数量
    updateGoodNum(data, num) {
      data.num = num;
      this.updateCartInfo(data);
    },
    updateCartInfo(data) {
      let _this = this;
      let url = "/api/order/addShoppingCart";
      var params = {
        cardNumber: data.cardNumber,
        code: this.shopInfo.shopCode,
        goodsSukId: data.goodsSkuId,
        mobile: this.cardInfo.tel,
        name: data.name,
        num: data.num,
        isCheck: data.isCheck,
        price: data.price,
        coverImg: data.coverImg,
        remarks: data.remarks,
      };

      apiPost(url, params)
        .then((resp) => {
          let _data = resp.data;
          if (_data.code == "0000") {
            this.getCartList();
          } else {
            _this.$toast.fail(_data.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //选择所有商品
    toggleAll() {
      let data = this.cartList[0];
      // data.goodsSukId = "";
      data.num = 0;
      if (this.checkAll) {
        data.isCheck = 2;
        this.updateCartInfo(data);
      } else {
        data.isCheck = 3;
      }
      
    },
    tobuy() {
      this.$router.push({ path: "buy" });
    },
  },
};
</script>


